// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 1000; /* Adjust as needed */
}
.navbar-container .semi-circle {
  width: 100px;
  height: 100px;
  background-color: #333; /* Color of the semi-circle */
  border-radius: 50%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%) rotate(180deg);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.navbar-container .navbar-content {
  background-color: #333; /* Color of the semi-circle */
  padding: 20px;
  box-shadow: 0px -2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 40px 40px 0 0;
  width: 100%; /* Adjust as needed */
  display: flex;
  color: white;
  justify-content: space-around;
}
.navbar-container .navbar-content .customnav svg path {
  fill: white;
}
.navbar-container .option2 {
  margin-right: 60px;
}
.navbar-container .option3 {
  margin-left: 60px;
}
.navbar-container img {
  cursor: pointer;
}
.navbar-container .qr-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Components/Common/Navbar/Navbar.scss"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,aAAA,EAAA,qBAAA;AAAF;AAGA;EACE,YAAA;EACA,aAAA;EACA,sBAAA,EAAA,6BAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,0CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AADF;AAKA;EAEE,sBAAA,EAAA,6BAAA;EACA,aAAA;EACA,2CAAA;EACA,4BAAA;EACA,WAAA,EAAA,qBAAA;EAEA,aAAA;EACA,YAAA;EACA,6BAAA;AALF;AAME;EACE,WAAA;AAJJ;AASA;EACE,kBAAA;AAPF;AASA;EACE,iBAAA;AAPF;AASA;EACE,eAAA;AAPF;AAUE;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AARF","sourcesContent":["\n.navbar-container {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  z-index: 1000; /* Adjust as needed */\n\n\n.semi-circle {\n  width: 100px;\n  height: 100px;\n  background-color: #333; /* Color of the semi-circle */\n  border-radius: 50%;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%) rotate(180deg);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n\n.navbar-content {\n\n  background-color: #333; /* Color of the semi-circle */\n  padding: 20px;\n  box-shadow: 0px -2px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 40px 40px 0 0;\n  width: 100%; /* Adjust as needed */\n  // max-width: 400px; /* Adjust as needed */\n  display: flex;\n  color: white;\n  justify-content: space-around;\n  .customnav svg path{\n    fill: white;\n  }\n\n}\n\n.option2{\n  margin-right: 60px;\n}\n.option3{\n  margin-left: 60px;\n}\nimg{\n  cursor: pointer;\n}\n  \n  .qr-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n// .active {\n//   fill: green; \n// }\n\n// .active:after {\n//   content: \"\";\n//   display: block;\n//   width: 20px; /* Adjust as needed */\n//   height: 3px; /* Height of the indicator */\n//   background-color: green;\n//   margin: 0 auto;\n// }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
